import { useSelector, useDispatch } from 'react-redux';
import type { RootState, AppDispatch } from '../store';
import { setCredentials, logout as logoutAction } from '../store/slices/authSlice';
import type { User } from '../services/authApi';

export function useAuth() {
  const dispatch = useDispatch<AppDispatch>();
  const { user, token, isAuthenticated } = useSelector((state: RootState) => state.auth);

  const login = (user: User, token: string) => {
    dispatch(setCredentials({ user, token }));
  };

  const logout = () => {
    dispatch(logoutAction());
  };

  return { user, token, isAuthenticated, login, logout };
}
